import { DataItemFormatter } from '@creditsights/styleguide-web';
import { ImpliedTag } from '../../../../../../services/dtos/issuer/issuerList.dto';
import { FilterDto, FilterType } from '../../../../../../models/Filter';

const TagsRenderer = (
  filterTagType: FilterType
): DataItemFormatter<ImpliedTag[], string | null, { tags: FilterDto[] }> => {
  return ({ value: implied }) => {
    const tags: string[] | undefined = implied
      ?.filter(({ type }) => type === filterTagType)
      .map(({ displayName }) => displayName);
    if (tags && tags.length > 0) {
      return tags.join(', ');
    }
    return null;
  };
};

export default TagsRenderer;
